<script setup lang="ts">
import CiSkeletonItem from '@/components/skeleton/CiSkeletonItem.vue';
</script>

<template>
  <div class="container">
    <div class="row mt-12">
      <div class="col-12">
        <CiSkeleton-Item class="mb-1 h-[38px] w-[70%]" />
        <div class="row">
          <div class="co-12 col-md-8">
            <CiSkeleton-Item class="my-6 h-[70px] w-full" />
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-4">
      <div class="col-12 col-lg-6">
        <CiSkeleton-Item class="mb-1 h-5 w-[30%]" />
        <CiSkeleton-Item class="mb-4 h-14 w-full" />
        <CiSkeleton-Item class="mb-1 h-5 w-[30%]" />
        <CiSkeleton-Item class="mb-4 h-14 w-full" />
        <CiSkeleton-Item class="mb-1 h-5 w-[30%]" />
        <CiSkeleton-Item class="mb-4 h-14 w-full" />
        <CiSkeleton-Item class="mb-1 h-5 w-[30%]" />
        <CiSkeleton-Item class="mb-4 h-14 w-full" />
      </div>
      <div class="col-12 col-lg-6 mt-6 lg:mt-0">
        <div class="flex h-full flex-col">
          <CiSkeleton-Item class="mb-1 h-5 w-[30%]" />
          <CiSkeleton-Item class="mb-4 h-full min-h-[154px]" />
        </div>
      </div>
      <div class="col-12 mt-4">
        <CiSkeleton-Item class="mx-auto mb-1 block h-5 w-[30%]" />
        <CiSkeleton-Item class="mx-auto mb-12 block h-5 w-[30%]" />
        <CiSkeleton-Item class="h-[70px] w-full" />
      </div>
    </div>

    <div class="row my-12">
      <div class="col-12 col-md-6 col-lg-3 offset-lg-3 order-2 mt-4 md:order-1 md:mt-0">
        <CiSkeleton-Item class="h-10 w-full" />
      </div>
      <div class="col-12 col-md-6 col-lg-3 order-1 md:order-2">
        <CiSkeleton-Item class="h-10 w-full" />
      </div>
    </div>
  </div>
</template>

<style></style>
